import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'buscausuario',
    templateUrl: './buscausuario.component.html',
    styleUrls: ['./buscausuario.component.scss'],
})
export class BuscausuarioComponent implements OnInit {
    @Input() data: any = [];
    @Output() sign = new EventEmitter();

    public term: string;
    public list: any = [];

    constructor() {}

    ngOnInit(): void {
        this.list = this.data;
    }

    public select(item) {
        this.sign.emit(item);
    }

    public search() {
        if (this.term) {
            this.list = this.data.filter(
                (item) =>
                    String(item.dsuser)
                        .toUpperCase()
                        .indexOf(String(this.term).toUpperCase()) > -1
            );
        } else {
            this.list = this.data;
        }
    }
}
